import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/base.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext"; // ✅ Import the provider
import { PageSettingsProvider } from "./context/PageSettingsContext";

// Initialize Web Vitals monitoring after initial render (deferred for performance)
// Adding delay to ensure Firebase Analytics is initialized first
if (import.meta.env.PROD && typeof window !== "undefined") {
  const initVitals = () => {
    import("./utils/webVitals")
      .then(({ initWebVitals }) => {
        initWebVitals();
      })
      .catch((error) => {
        console.warn("Web Vitals failed to load:", error);
      });
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(initVitals, { timeout: 2000 });
  } else {
    setTimeout(initVitals, 2000);
  }
}

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <PageSettingsProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </PageSettingsProvider>
  </StrictMode>,
);
